import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { planSummaryEntryPoint } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-summary/entrypoint.tsx';
import { plansHorizontalNavigationEntryPoint } from '@atlassian/jira-horizontal-nav-plans/entrypoint.tsx';

export const planSummaryPageEntryPoint = createPageEntryPoint({
	main: planSummaryEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
	horizontalNavigation: plansHorizontalNavigationEntryPoint,
});

export const planSummaryPageEntryPointWithoutHorizontalNavigation = createPageEntryPoint({
	main: planSummaryEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
});
